import { ElationPatientCreateAccount } from 'api/elation/routes'
import useAxiosWithAuth from 'api/useAxiosWithAuth'

interface UseElationInterface {
  createElationAccount: () => Promise<number | undefined>
}

const useElation = (): UseElationInterface => {
  const axiosWithAuth = useAxiosWithAuth()

  const createElationAccount = async (): Promise<number | undefined> => {
    const response = await axiosWithAuth.post(ElationPatientCreateAccount)
    return response.data
  }

  return {
    createElationAccount,
  }
}

export default useElation
